#root {
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
}

.App {
  width: 100%;
}

.App-header {
  margin-bottom: 2rem;
}

.App-header h1 {
  color: #646cff;
  margin-bottom: 0.5rem;
}

.App-header p {
  color: #888;
  font-size: 1.1rem;
}

.App-main {
  margin: 2rem 0;
}

.decoder-section {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
  border: 1px solid #333;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.05);
}

.input-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

.input-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #ccc;
}

.input-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #444;
  border-radius: 8px;
  background-color: #1a1a1a;
  color: white;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  resize: vertical;
  box-sizing: border-box;
}

.input-group textarea:focus {
  outline: none;
  border-color: #646cff;
}

.decode-btn {
  background-color: #646cff;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.25s;
}

.decode-btn:hover {
  background-color: #535bf2;
}

.platform-switch {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: rgba(100, 108, 255, 0.1);
  border: 1px solid #646cff;
  border-radius: 8px;
  text-align: center;
}

.switch-platform-btn {
  background-color: #646cff;
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.25s;
}

.switch-platform-btn:hover {
  background-color: #535bf2;
}

.result-section {
  margin-top: 2rem;
  text-align: left;
}

.result-section h3 {
  margin-bottom: 1rem;
  color: #646cff;
}

.result-content {
  padding: 1rem;
  background-color: #1a1a1a;
  border: 1px solid #444;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-break: break-all;
}

.docs-section {
  max-width: 600px;
  margin: 3rem auto 2rem;
  padding: 2rem;
  text-align: left;
}

.docs-section h2 {
  color: #646cff;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.id-types-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.id-types-list li {
  padding: 1rem;
  margin-bottom: 0.75rem;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid #333;
  border-radius: 8px;
}

.id-type-title {
  margin-bottom: 0.5rem;
}

.id-type-title a {
  color: #646cff;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.25s;
}

.id-type-title a:hover {
  color: #535bf2;
  text-decoration: underline;
}

.id-type-description {
  font-size: 0.85rem;
  color: #aaa;
  line-height: 1.4;
}

.generate-link {
  font-size: 0.85rem;
  color: #888 !important;
  font-style: italic;
  text-decoration: none;
}

.generate-link:hover {
  color: #646cff !important;
  text-decoration: underline;
}

.App-footer {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #333;
  color: #888;
  font-size: 0.9rem;
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1rem;
}

.footer-separator {
  color: #555;
}

.privacy-policy-link {
  background: none;
  border: none;
  color: #888;
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: underline;
  padding: 0.25rem 0.5rem;
  transition: color 0.25s;
}

.privacy-policy-link:hover {
  color: #646cff;
}

.back-btn {
  background: none;
  border: none;
  color: #646cff;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 0.5rem;
  padding: 0.5rem;
  transition: color 0.25s;
}

.back-btn:hover {
  color: #535bf2;
  text-decoration: underline;
}

@media (prefers-color-scheme: light) {
  .decoder-section {
    background-color: rgba(0, 0, 0, 0.05);
    border-color: #ddd;
  }

  .input-group label {
    color: #333;
  }

  .input-group textarea {
    background-color: white;
    color: #333;
    border-color: #ddd;
  }

  .result-content {
    background-color: #f9f9f9;
    border-color: #ddd;
    color: #333;
  }

  .id-types-list li {
    background-color: rgba(0, 0, 0, 0.05);
    border-color: #ddd;
  }

  .id-type-description {
    color: #666;
  }

  .App-footer {
    border-color: #ddd;
    color: #666;
  }
}
